// extracted by mini-css-extract-plugin
export default {"item":"Item_item__Yvxr7","avatar":"Item_avatar__f+3Ms","man":"Item_man__7Q+7G","position":"Item_position__tf7o1"};